// @ts-nocheck
// Simplified from tailuge/billiards (GPL-3.0) — src/utils/cueintersect.ts
// Modified: balls have no view mesh in this integration, so the cue-clip
// avoidance check is disabled (returns false). Safe no-op for aiming.
export function cueIntersectsAnything(_table, _aim, _offset): boolean {
  return false
}
